import React, { Component } from 'react';
import { Tabs } from 'antd';
import HouseTypeDetail from '@/components/HouseTypeDetail';
// import ThressViews from '@/components/ThressViews';
import GraphicSolution from '@/components/GraphicSolution';
import ConstructionDrawing from '&/components/ConstructionDrawing';
import ConstructionSchedule from '@/components/ConstructionSchedule';
import BudgetList from '@/components/BudgetList';
import { isMobile } from '&/utils/common';

import './index.scss';

const { TabPane } = Tabs;

export default class DesignDetail extends Component {
    tabChange = (...arg) => {
        console.log(arg);
    };

    render() {
        return (
            <div className="design-detail">
                <Tabs
                    centered={isMobile() ? true : false}
                    defaultActiveKey={
                        isMobile() ? 'graphicSolution' : 'houseType'
                    }
                    onChange={this.tabChange}
                    size="large">
                    {!isMobile() && (
                        <TabPane
                            tab={intl.get('decorationDesign.houseType')}
                            className="hidden-in-mobile"
                            key="houseType">
                            <HouseTypeDetail {...this.props}></HouseTypeDetail>
                        </TabPane>
                    )}
                    {/* {!isMobile() && (
                        <TabPane
                            tab={intl.get('decorationDesign.threeViews')}
                            className="hidden-in-mobile"
                            key="threeViews">
                            <ThressViews {...this.props}></ThressViews>
                        </TabPane>
                    )} */}
                    <TabPane
                        tab={intl.get('decorationDesign.graphicSolution')}
                        key="graphicSolution">
                        <GraphicSolution {...this.props}></GraphicSolution>
                    </TabPane>
                    <TabPane
                        tab={intl.get('decorationDesign.constructionDrawing')}
                        key="constructionDrawing">
                        <ConstructionDrawing
                            {...this.props}></ConstructionDrawing>
                    </TabPane>
                    {!isMobile() && (
                        <TabPane
                            tab={intl.get(
                                'decorationDesign.constructionSchedule'
                            )}
                            className="hidden-in-mobile"
                            key="constructionSchedule">
                            <ConstructionSchedule
                                {...this.props}></ConstructionSchedule>
                        </TabPane>
                    )}
                    {!isMobile() && (
                        <TabPane
                            disabled
                            className="hidden-in-mobile"
                            tab={intl.get(
                                'decorationDesign.contractSmartAssistant'
                            )}
                            key="contractSmartAssistant">
                            {intl.get(
                                'decorationDesign.contractSmartAssistant'
                            )}
                        </TabPane>
                    )}
                    {!isMobile() && (
                        <TabPane
                            className="hidden-in-mobile"
                            tab={intl.get('decorationDesign.budgetList')}
                            key="budgetList">
                            <BudgetList {...this.props}></BudgetList>
                        </TabPane>
                    )}
                </Tabs>
            </div>
        );
    }
}
